<template>
    <div>
        <v-app-bar
            elevation="0"
            fixed
            :color="topBarBgcolor||$vuetify.theme.themes.light.headerBgColor"
            class="yabocp-appbar-container"
            :style="{ ...appbarStyle, '--logoMaxWidth': logoObj.width, '--logoMaxHeight': logoObj.height }"
            light
        >
            <slot name="left">
                <v-btn :color="headerColor" @click="routeBack" text>
                    <i class="iconfont jiantou-left"></i>
                </v-btn>
            </slot>

            <slot>
                <v-toolbar-title>
                    <span class="page-title" :style="'color:'+headerColor">{{title}}</span>
                </v-toolbar-title>
            </slot>

            <slot name="right">
                <v-btn text>
                    <a :href="onlineQQUrl" target="_black" style="color:white;">
                        <i class="iconfont icon-test"></i>
                    </a>
                </v-btn>
            </slot>
        </v-app-bar>
        <div v-if="holder" class="yabocp-appbar-container"></div>
    </div>
</template>
<script>
import appConfigMixins from "@c/mixins/appConfig.mixins";
export default {
    mixins: [appConfigMixins],
    props: {
        title: {
            type: [String],
            default: ""
        },
        holder: {
            type: [Boolean],
            default: true
        },
        topBarBgcolor: {
            type: String,
            default: ""
        },
        appbarStyle: {
            default: ""
        }
    },
    computed: {
        onlineQQUrl() {
            //在线客服地址
            return this.$store.state.sysParameter.onlineQQUrl;
        },
        headerColor() {
            return this.$vuetify.theme.themes.light.headerColor;
        },
        logoObj() {
          //   测试

          let obj = {
            width: '3.2rem',
            height: '1.06667rem'
          }
          try {
            let { maxWidthH5 = '3.2rem', maxHeightH5 = '1.06667rem' } =
              this.$store.state.app.appConfig.app_config.configValue.headerLogoConfig || {}

            obj.width = maxWidthH5 || '3.2rem'
            obj.height = maxHeightH5 || '1.06667rem'
          } catch (e) {}

          return obj
        },
    },
  
};
</script>
<style lang="scss">
@import "~/assets/common/variables.scss";
.yabocp-appbar-container {
    // height: 36px !important;
    height: $topbar-height !important;
    .wodexuanzhong,
    .icon-test {
        font-size: 24px;
        // color:#fff
    }
    .v-toolbar__title {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        font-size: 0;
        flex: 1;
        text-align: center;
    }
    .v-toolbar__content {
        // height: 36px !important;
        height: $topbar-height !important;
        padding: 2px 8px 2px 8px;
        display: flex;
        justify-content: space-between;
    }
    .page-title {
        font-size: 17px;
        text-align: center;
        // color: #fff;
    }
    .appbar-button-text {
        color: #fff;
    }
    .bar-logo {
      max-width: var(--logoMaxWidth);
      max-height: var(--logoMaxHeight);
    }
}
</style>